module.exports = __webpack_public_path__ + "static/media/valentina_guerrero_marin_11.8efb7671.jpg";